import { render } from "./Storico.vue?vue&type=template&id=86c898bc"
import script from "./Storico.vue?vue&type=script&lang=js"
export * from "./Storico.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__